import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { configureLogging, createLogger } from './app/core/logging/logging';
import { environment } from './environments/environment';

configureLogging(environment.logLevel, 'Pridehub.ExternalWebsite');
const bootstrapLogger = createLogger('Bootstrap');

bootstrapApplication(App, appConfig)
  .catch((err) => bootstrapLogger.error('Bootstrap failed', err));
